import React from "react";
import { Dialog, Flex, Text, Button } from "@radix-ui/themes";

export function ComoGPSWarningDialog({ isOpen, onOpenChange, data }) {
  if (!data) return null;

  const { message, locations, required_flag } = data;

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const required_flag_name = capitalize(required_flag.replace("_flag", "").replaceAll("_", " "));

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="500px">
        <Dialog.Title>Manual Update Required</Dialog.Title>

        <Dialog.Description size="2" mb="4">
          {message}
        </Dialog.Description>

        <Text size="2" weight="regular" mb="2">
          Affected Locations:
        </Text>

        <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
          {locations?.map((loc, i) => (
            <li key={i}>
              <Text size="2">{loc}</Text>
            </li>
          ))}
        </ul>

        <Text size="2" mb="4">
          Required field to enable: <strong>{required_flag_name}</strong>
        </Text>

        <Flex justify="end">
          <Dialog.Close>
            <Button variant="soft" size="2">
              Got it
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
